const SmallOrderMaterialLibrary = () => import('@/views/main/promotion/smallOrderMaterialLibrary/SmallOrderMaterialLibrary.vue')
export default {
  path: '/main/promotion/smallOrder/materialLibrary',
  name: 'SmallOrderMaterialLibrary',
  component: SmallOrderMaterialLibrary,
  children: []
}
